import EmblaCarousel from '@/components/EmblaCarousel';
import Image from 'next/image';
import { Fragment } from 'react';
export const WhatDoesTheLifetimeWarrantyCover = () => {
  const slides = [1, 2];
  const OPTIONS = {
    containScroll: false,
    align: 'start',
  };
  return (
    <div className=' py-[40px] lg_py-[80px]'>
      <div className=' personalContent lg-mb-[40px] mx-auto mb-[20px] lg_mb-[35px]'>
        <div className=' px-[12px] lg_px-0'>
          <h2
            id='coverage'
            className='mb-[10px] text-left font-teko-medium text-[30px] uppercase leading-[28px] lg_mb-[20px] lg_text-[40px] lg_leading-[48px]'
          >
            What Does the Lifetime Warranty Cover?
          </h2>

          <h3 className='mb-[10px] font-roboto-regular text-[16px] font-normal leading-[24px] lg_text-[18px] lg_leading-[30px]'>
            The HISEA Lifetime Warranty covers defects in materials and workmanship under normal use. We want to make
            sure your boots live up to the rugged standards you expect from us. That said, certain conditions apply.
          </h3>
          <h4 className='mb-[20px] font-roboto-medium text-[16px] font-medium leading-[24px] lg_mb-[0px] lg_text-[18px] lg_leading-[30px]'>
            Please note that the Lifetime Warranty applies to HISEA boots and waders only. It does not cover other
            products in our range.
          </h4>
        </div>
      </div>
      <div className='personalContent mx-auto'>
        <div className='w-full px-[12px] lg_px-0'>
          <EmblaCarousel
            slides={slides}
            options={OPTIONS}
            classes={{
              content: 'lg_grid-cols-2',
            }}
          >
            {(item, index) => (
              <Fragment key={index}>
                {item === 1 ? (
                  <div
                    datatype='cover'
                    className=' border-1 border-solid border-[#E0E0E0] bg-[#fff]'
                  >
                    <div className=' flex h-[60px] items-center justify-center gap-[10px] bg-[#000] lg_h-[80px]'>
                      <Image
                        src={`/warranty-page/cover.svg`}
                        alt='warranty-icon-1'
                        width={40}
                        height={40}
                        className='h-[30px] w-[30px] lg_h-[40px] lg_w-[40px]'
                      />

                      <span className='font-roboto-medium text-[18px] text-white lg_text-[20px]'>Covered</span>
                    </div>

                    <div className='px-[12px] py-[20px] lg_px-[40px]'>
                      <h3 className='mb-[10px] font-roboto-medium text-[18px] font-medium'>Manufacturing Defects</h3>

                      <p className='font-roboto-light text-[16px] font-light leading-[26px]'>
                        Any issues caused by manufacturing defects, including:
                      </p>

                      <ul className=''>
                        <li className='flex items-start font-roboto-light text-[16px] font-light leading-[26px]'>
                          <span className='mr-[10px] mt-[10px] inline-block !h-[3px] !min-h-[3px] !w-[3px] !min-w-[3px] rounded-[3px] bg-[#000] '></span>
                          Poor stitching, broken seams, or faulty adhesives.
                        </li>

                        <li className='flex items-start font-roboto-light text-[16px] font-light leading-[26px]'>
                          <span className='mr-[10px] mt-[10px] inline-block !h-[3px] !min-h-[3px] !w-[3px] !min-w-[3px] rounded-[3px] bg-[#000] '></span>
                          Defective materials, such as a zipper that breaks prematurely or waterproofing that fails
                          without misuse.
                        </li>

                        <li className='flex items-start font-roboto-light text-[16px] font-light leading-[26px]'>
                          <span className='mr-[10px] mt-[10px] inline-block !h-[3px] !min-h-[3px] !w-[3px] !min-w-[3px] rounded-[3px] bg-[#000] '></span>
                          Structural defects that affect the integrity of the boots during normal use.
                        </li>
                      </ul>
                    </div>

                    <div className='border-t-1 border-solid border-[#E0E0E0] px-[12px] py-[40px] lg_px-[40px] lg_py-[30px]'>
                      <h3 className='mb-[10px] font-roboto-medium text-[18px] font-medium leading-[24px]'>
                        Workmanship Errors
                      </h3>

                      <p className='mb-[10px] font-roboto-light text-[16px] font-light leading-[26px]'>
                        Problems caused by errors during the boot assembly or manufacturing process that lead to
                        premature failure.
                      </p>
                    </div>

                    <div className='border-t-1 border-solid border-[#E0E0E0]  px-[12px] py-[40px] lg_px-[40px] lg_py-[30px]'>
                      <h3 className='mb-[10px] font-roboto-medium text-[18px] font-medium  leading-[24px]'>
                        Defective Hardware
                      </h3>
                      <p className='mb-[10px] font-roboto-light text-[16px] font-light leading-[26px]'>
                        Any components, such as buckles, zippers, or laces, that fail due to faulty construction or
                        defective materials.
                      </p>
                    </div>
                  </div>
                ) : (
                  <div
                    datatype='not cover'
                    className=' border-1 border-solid border-[#E0E0E0] bg-[#fff]'
                  >
                    <div className=' flex h-[60px] items-center justify-center gap-[10px] bg-[#E0E0E0] lg_h-[80px]'>
                      <Image
                        src={`/warranty-page/notCover.svg`}
                        alt='warranty-icon-2'
                        width={40}
                        height={40}
                        className='h-[30px] w-[30px] lg_h-[40px] lg_w-[40px]'
                      />

                      <span className='font-roboto-medium text-[18px] text-[#4C4C4C]  lg_text-[20px]'>Not Covered</span>
                    </div>

                    <div className='px-[12px] py-[18px] lg_px-[40px] lg_py-[18px]'>
                      <h3 className='mb-[10px] font-roboto-medium text-[18px] font-medium'>Normal Wear and Tear</h3>

                      <p className='font-roboto-light text-[16px] font-light leading-[26px]'>
                        This includes natural deterioration of the product over time, such as holes from wear, snags,
                        scuffs on the uppers (rubber/textile) and soles, faded colors, and worn stitching.
                      </p>
                    </div>

                    <div className=' border-t-1  border-solid border-[#E0E0E0] px-[12px] py-[17px] lg_px-[40px] lg_py-[18px]'>
                      <div className='mb-[10px] font-roboto-medium text-[18px] font-medium  leading-[24px]'>
                        Damage Caused by Accidents or Misuse
                      </div>

                      <p className=' font-roboto-light text-[16px] font-light leading-[26px]'>
                        Any damage resulting from improper use, neglect, or accidents is not covered under the warranty.
                      </p>
                    </div>

                    <div className=' border-t-1  border-solid border-[#E0E0E0]  px-[12px] py-[17px] lg_px-[40px] lg_py-[18px]'>
                      <div className='mb-[10px] font-roboto-medium text-[18px] font-medium  leading-[24px]'>
                        Issues Related to Exposure to Extreme Conditions
                      </div>

                      <p className='font-roboto-light text-[16px] font-light leading-[26px]'>
                        Damage caused by exposure to extreme heat, chemicals, or other environmental factors beyond the
                        product’s intended use is not covered.
                      </p>
                    </div>

                    <div className=' border-t-1  border-solid border-[#E0E0E0] px-[12px] py-[17px] lg_px-[40px] lg_py-[18px]'>
                      <div className='mb-[10px] font-roboto-medium text-[18px] font-medium  leading-[24px]'>
                        Unauthorized Modifications or Repairs
                      </div>

                      <p className='font-roboto-light text-[16px] font-light leading-[26px]'>
                        Any alterations or repairs made by unauthorized personnel will void the warranty.
                      </p>
                    </div>
                  </div>
                )}
              </Fragment>
            )}
          </EmblaCarousel>
        </div>
      </div>
    </div>
  );
};
